const getXmlStringFromBlob = async (blob: Blob) => {
    return await blob.text()
}

const stripXmlDeclaration = (xml: string) => {
    return xml.replace(/^<\?xml[^>]*\?>\s*/i, '').trim()
}

export const handleDownloadXml = async (blobs: Blob[]) => {
    const xmlStrings = await Promise.all(
        blobs.map((blob) =>
            getXmlStringFromBlob(blob).then(stripXmlDeclaration)
        )
    )

    const finalXml =
        '<?xml version="1.0" encoding="UTF-8"?>\n<collection>\n' +
        xmlStrings.join('\n') +
        '\n</collection>'

    const blob = new Blob([finalXml], { type: 'application/xml' })

    return blob
}
